// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"53e51b0c","918":"0217c9f2"}[chunkId] + ".chunk.js";
};